import Box from '@mui/material/Box';
import { alpha } from '@mui/material/styles';
import type { FC, ReactNode } from 'react';
import { NAVY } from 'styles/tokens';

import { BackButton, PrimaryButton } from '../atoms/FormButtons';

interface StepActionsProps {
  onBack?: () => void;
  onNext?: () => void;
  backLabel?: string;
  nextLabel?: string;
  nextDisabled?: boolean;
  nextLoading?: boolean;
  /** Optional sticky-on-scroll behaviour for long forms. */
  sticky?: boolean;
  /** Custom slot rendered between Back and Next (e.g., a "Save draft" button). */
  extra?: ReactNode;
}

const StepActions: FC<StepActionsProps> = ({
  onBack,
  onNext,
  backLabel = 'Volver',
  nextLabel = 'Continuar',
  nextDisabled,
  nextLoading,
  sticky,
  extra,
}) => (
  <Box
    sx={{
      mt: 5,
      pt: 3,
      borderTop: `1px solid ${alpha(NAVY, 0.06)}`,
      display: 'flex',
      flexDirection: { xs: 'column-reverse', sm: 'row' },
      justifyContent: 'space-between',
      alignItems: { xs: 'stretch', sm: 'center' },
      gap: 1.5,
      ...(sticky && {
        position: 'sticky',
        bottom: 0,
        bgcolor: 'rgba(249, 250, 253, 0.85)',
        backdropFilter: 'blur(16px)',
        borderRadius: 0,
        py: 2,
        zIndex: 2,
      }),
    }}
  >
    <Box sx={{ display: 'flex', gap: 1 }}>{onBack && <BackButton onClick={onBack}>{backLabel}</BackButton>}</Box>
    <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center', flexWrap: 'wrap' }}>
      {extra}
      {onNext && (
        <PrimaryButton onClick={onNext} disabled={nextDisabled || nextLoading}>
          {nextLoading ? 'Procesando…' : nextLabel}
        </PrimaryButton>
      )}
    </Box>
  </Box>
);

export default StepActions;
